import React from 'react';
import { WebsiteDesignProps } from './types';
import { Sun, Moon, Star, Hexagon } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MoroccanMosaic: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Atlas Academy";

    return (
        <div className="bg-[#cba474] min-h-screen font-serif text-[#4a3b2a]">
            {/* Pattern Overlay */}
            <div className="fixed inset-0 pointer-events-none opacity-10" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0l30 30-30 30L0 30z' fill='%236b4c35' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`
            }}></div>

            <nav className="bg-[#994d4d] text-[#f4ecd8] p-6 relative z-10 border-b-8 border-[#3d5a80]">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <Hexagon className="fill-[#f4ecd8] text-[#994d4d]" />
                        <span className="text-2xl font-bold tracking-widest uppercase">{schoolName}</span>
                    </div>
                    <div className="flex gap-6 uppercase text-sm font-bold tracking-wider">
                         <a href="#" className="hover:text-[#3d5a80] transition-colors">Oasis</a>
                         <a href="#" className="hover:text-[#3d5a80] transition-colors">Caravan</a>
                         <a href="#" className="hover:text-[#3d5a80] transition-colors">Library</a>
                    </div>
                </div>
            </nav>

            <main className="container mx-auto px-6 py-12 relative z-10">
                <div className="bg-[#f4ecd8] p-8 md:p-16 rounded-t-[10rem] shadow-xl border-x-8 border-t-8 border-[#3d5a80] text-center max-w-4xl mx-auto">
                    <h1 className="text-5xl md:text-7xl font-bold text-[#994d4d] mb-8 font-serif">
                        Geometric <br/> Wisdom
                    </h1>
                    <p className="text-xl text-[#6b4c35] mb-12 leading-relaxed">
                        Structure, beauty, and history interwoven into a curriculum that stands the test of time.
                    </p>
                    <div className="flex justify-center gap-4">
                        <Button className="bg-[#3d5a80] text-[#f4ecd8] hover:bg-[#293c54] rounded-none px-8 py-6 uppercase tracking-widest text-xs font-bold shadow-lg">
                            Begin Journey
                        </Button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 mt-0 max-w-4xl mx-auto border-b-8 border-x-8 border-[#3d5a80] bg-[#3d5a80]">
                     <div className="aspect-square bg-[#e29578] flex items-center justify-center p-8 hover:bg-[#e29578]/90 transition-colors">
                         <Sun size={48} className="text-[#f4ecd8]" />
                     </div>
                     <div className="aspect-square bg-[#f4ecd8] p-6 flex flex-col justify-center text-center">
                         <h3 className="text-lg font-bold text-[#994d4d] uppercase mb-2">Morning</h3>
                         <p className="text-xs text-[#6b4c35]">Mathematics & Geometry</p>
                     </div>
                     <div className="aspect-square bg-[#81b29a] flex items-center justify-center p-8 hover:bg-[#81b29a]/90 transition-colors">
                         <Moon size={48} className="text-[#f4ecd8]" />
                     </div>
                     <div className="aspect-square bg-[#f4ecd8] p-6 flex flex-col justify-center text-center">
                         <h3 className="text-lg font-bold text-[#994d4d] uppercase mb-2">Evening</h3>
                         <p className="text-xs text-[#6b4c35]">Astronomy & Philosophy</p>
                     </div>
                </div>
            </main>
        </div>
    );
};

export default MoroccanMosaic;
